import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Hide,
  Show,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import { useSideBarContext } from '../hooks/sideBarContext';
import { colors } from 'packages/common-frontend/colors';

export const SideBar: React.FC = ({ children }) => {
  const { sideBarOpen, toggleSideBar } = useSideBarContext();

  const background = useColorModeValue('#f9f6f1', '');
  const borderRight = useColorModeValue(
    `1px solid ${colors.gray['200']}`,
    'none',
  );
  const boxShadow = useColorModeValue('0 0 4px hsl(0deg 0% 76% / 35%)', 'none');

  return (
    <>
      <Hide above="lg">
        <Drawer
          isOpen={sideBarOpen}
          size="full"
          isFullHeight
          placement="top"
          onClose={() => {
            toggleSideBar();
          }}
        >
          <DrawerOverlay>
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerBody marginTop="75px">
                <VStack align="left">{children}</VStack>
              </DrawerBody>
            </DrawerContent>
          </DrawerOverlay>
        </Drawer>
      </Hide>

      <Show above="lg">
        <Flex
          direction="column"
          justify="space-between"
          p="20px 30px"
          minW="255px"
          bg={background}
          borderRight={borderRight}
          boxShadow={boxShadow}
        >
          <VStack align="left">{children}</VStack>
        </Flex>
      </Show>
    </>
  );
};
